.wrapper {
  display: flex;
}

.tab,
.active {
  border-bottom: 1px solid var(--color-easil-gray-x-light);
  color: var(--color-easil-gray-dark);
  cursor: pointer;
  font-size: 16px;
  padding: 8px 16px;
  transition: 300ms all ease-in-out;
}

.active,
.tab:hover {
  border-bottom-color: var(--color-easil-black);
  color: var(--color-easil-black);
}
